import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from "axios";
import {clientApi} from '@/http/ClientApi';

Vue.use(VueI18n);
export const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en'
});

// const loadedLanguages = ['en'];

function setI18nLanguage(lang: string) {
    i18n.locale = lang;
    axios.defaults.headers.common['Accept-Language'] = lang;
    document.querySelector('html')?.setAttribute('lang', lang);
    return lang;
}

export function loadLanguageAsync(lang: string) {
    if (typeof lang === 'undefined') {
        lang = window.navigator.language;
        lang = lang.slice(0, 2);
    }
    // if (loadedLanguages.includes(lang)) {
    //     if (i18n.locale !== lang) {
    //         setI18nLanguage(lang);
    //     }
    //     return Promise.resolve();
    // }
    return clientApi.getTranslations().then((response) => {
        // loadedLanguages.push(lang);
        i18n.setLocaleMessage(lang, response);
        return setI18nLanguage(lang);
    }).catch((e) => {
        console.log(e);
    });
}

